import Observer from '@/js/helpers/Observer';
import Z from '../Z';

const ROW_SELECTOR = ".sticky-move", // selector of rows with moving columns
    COL_SELECTOR = ".stick", // selector of moving columns inside the rows
    ACTIVE_BREAKPOINT = 768;
let options,
    items = [], // array of the rows
    observer = new Observer(observe), // IntersectionObserver for the rows
    debug = {
        options,
        items,
        active: false // state flag
    }

/**
 * Find moving columns in selector rows
 * and set them when all images inside each row have been loaded
 * @param {string} rowSelector
 */
function start (o = {}) {
    options = Object.assign({}, o, {
        rowSelector: ROW_SELECTOR,
        colSelector: COL_SELECTOR,
        breakpoint: ACTIVE_BREAKPOINT
    });
    debug.options = options;
    $(options.rowSelector).each((i, row) => {
        let $cols = $(row).find(options.colSelector);
        if ($cols.length < 2) return;
        Z.onLoadImages(row, () => addItem(row));
    });
    $(window).on("resize", onAppResize);
    debug.active = false;
    onAppResize();
    Z.on('ImageLoad', () => onAppScroll());
}

function onAppResize () {
    Z.vw < options.breakpoint ? deactivate() : activate();
}

/**
 *  observin
 */
function activate () {
    if (debug.active) return;
    debug.active = true;
    items.forEach(row => {
        if (row.cols) row.cols.forEach(col => Z.translate(col.el, 0, 0));
        setItem(row);
        observer.observe(row);
    });
    Z.on('AppScroll', onAppScroll);
}

function deactivate () {
    if (!debug.active) return;
    Z.off('AppScroll', onAppScroll);
    debug.active = false;
    items.forEach(row => {
        observer.unobserve(row);
        if (row.cols) row.cols.forEach(col => Z.translate(col.el, 0, 0));
    });
}

function addItem (row) {
    items.push(row);
    if (Z.vw > options.breakpoint) observer.observe(row);
}

function observe (entries) {
    let row;
    entries.forEach(entry => {
        row = entry.target;
        row.sticky = entry.intersectionRatio > 0;
        if (row.sticky && !row.cols) setItem(row);
    });
}

/**
 * Pre-calculate geometry
 * @param {Element} item
 */
function setItem (item) {
    let cols = [],
        $cols = $(item).find('.stick'),
        rowBB = item.getBoundingClientRect();

    delete item.cols;
    $cols.each((i, el) => {
        let { y, height } = el.getBoundingClientRect();
        if (height > rowBB.height - 10) return;
        let margin = 60;
        let start = rowBB.y + height - Z.vh + Z.scrollY + margin,
            end = rowBB.bottom - height + Z.scrollY - margin,
            min = rowBB.y - y,
            max = min + rowBB.height - height;
        cols.push({ el, min, max, start, end });
    });

    item.cols = cols;

}

function onAppScroll () {
    items.forEach(row => {
        if (!row.sticky) return;
        row.cols.forEach(col => Z.translate(col.el, 0, Z.lin(Z.scrollY, col) + 'px'));
    })
}

function destroy () {
    items.forEach(item => observer.unobserve(item));
    items.splice(0, items.length)
}

window.StickyMove = debug;
export default { start, destroy };
